// extracted by mini-css-extract-plugin
export default {"main":"Products_main__cvaGD","navCatalogo":"Products_navCatalogo__iKGfP"};